import API from 'services/api';

interface IUpdateCancellationPolicy {
  isActive: boolean;
}

export const updateCancellationPolicy = ({
  policyId,
  payload,
}: {
  policyId: string;
  payload: IUpdateCancellationPolicy;
}) => {
  return API.patch(`/api/accommodation/cancellation-policy/${policyId}`, payload);
};
